<template>
  <v-container class="ma-0 pa-0" fluid>
    <v-data-table
      :class="table"
      :headers="headers"
      :height="tableSize"
      :items-per-page="pageSize"
      :items.sync="filteredAdPlanners"
      :loading="loading"
      dense
      style="cursor:pointer"
      sort-by="ad_start_date"
      sort-desc
      item-key="adId"
      color="#fff"
      fixed-header
      loading-text="Loading... Please Wait"
      no-results-text="No Matching Ad Planners Found"
      :no-data-text="selectedStore ? 'No Ad Planners Found' : 'Please Select Store to View Ad Planners'"
      @click:row="viewAdPlanner"
      hide-default-footer>
      <template #top>
        <v-toolbar flat color="toolbar" height="75" style="cursor:default;">
          <v-toolbar-title>Edit Ad Planner SRP</v-toolbar-title>
          <v-divider vertical inset class="mx-4"/>
          <v-row dense align="center">
            <v-col md="4" lg="3">
              <v-autocomplete
                :class="body"
                auto-select-first
                v-model="selectedAdGroup"
                :items="userAdGroups"
                item-text="name"
                item-value="id"
                return-object
                hide-no-data
                class="mt-7"
                background-color="input"
                label="Ad Group"
                outlined
                dense
                prepend-inner-icon="mdi-filter-outline"
                :menu-props="{ maxHeight: 260 }"
                :rules="[v => !!v ||  'Required']">
                <template v-slot:item="data">
                  <template>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ data.item.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="text-capitalize">
                        Ad Group
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                :class="body"
                auto-select-first
                v-model="selectedStore"
                :items="storeParties"
                item-text="name"
                item-value="id"
                return-object
                class="mt-7"
                background-color="input"
                placeholder="Select Store"
                label="Store"
                outlined
                dense
                prepend-inner-icon="mdi-filter-outline"
                :menu-props="{ maxHeight: 260, rounded: '' }"
                :disabled="!selectedAdGroup"
                :rules="[v => !!v ||  'Required']">
                <template v-slot:item="data">
                  <template>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ data.item.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="text-capitalize">
                        Store
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col v-if="suggestedOrderStore" cols="2">
              <v-select
                :class="body"
                class="mt-7"
                auto-select-first
                v-model="suggestedFilter"
                :items="suggestedFilterOptions"
                background-color="input"
                placeholder="Select Store"
                label="Filter Ad Type"
                outlined
                dense
                prepend-inner-icon="mdi-filter-outline"
                :menu-props="{ maxHeight: 260, offsetY: true, rounded: '' }">
              </v-select>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>

      <template #[`item.ad_details`]="{ item }">
        <v-menu
          open-on-hover
          offset-y
          bottom
          :close-on-content-click="false">
          <template #activator="{ on }">
            <v-btn
              v-on="on"
              icon
              @click.stop="">
              <v-icon>mdi-information</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Ad ID</v-list-item-subtitle>
                  <v-list-item-title>{{ item.ad_id }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Created On</v-list-item-subtitle>
                  <v-list-item-title>{{
                    formatDateTimestamp(item.created_on)
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Created By</v-list-item-subtitle>
                  <v-list-item-title>{{ item.created_by }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </template>

      <template #[`item.ad_start_date`]="{ item }">
        {{formatDateDisplay(item.ad_start_date)}}
      </template>

      <template #[`item.ad_end_date`]="{ item }">
        {{formatDateDisplay(item.ad_end_date)}}
      </template>

      <template #[`item.lastOrderDate`]="{ item }">
        {{formatDateDisplay(item.lastOrderDate)}}
      </template>

      <template #[`item.ad_status`]="{ item }">
        <!-- {{ getEditStatus(item) }} -->
        <v-chip class="mr-2" small dark :class="getEditStatus(item).color">
          <span style=" display: inline-block; margin: 0 auto; width: 120px; text-align: center;">
            <span>{{ getEditStatus(item).status_name }}</span>
          </span>
        </v-chip>
      </template>

      <template v-slot:footer>
        <v-divider></v-divider>
        <v-toolbar flat color="toolbar">
          <v-row align="center">
            <v-spacer></v-spacer>
            <v-col cols="2" style="max-width:150px;">
              <v-select
                class="mt-8"
                dense
                :items="pageSizes"
                label="Items Per Page"
                v-model="pageSize"
                :menu-props="{ top: true, offsetY: true, maxHeight: 500 }">
              </v-select>
            </v-col>
            <v-btn
              icon
              large
              @click="previous"
              :disabled="disablePrevious"
              class="mx-2">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <small>Page {{ page }}</small>
            <v-btn icon large
              @click="next"
              :disabled="disableNext"
              class="mx-2">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-row>
        </v-toolbar>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
// api
import AdRetails from '@/axios/ad-retails'
import Party from '@/axios/party'
// mixins
import { displayAlert } from '@/mixins/alert'
import { fullwidth } from '@/mixins/fullwidth'
import { partySearch } from '@/mixins/party-search'
import { paging } from '@/mixins/paging'
import { utils } from '@/mixins/utils'
import { displayHelpers } from '@/mixins/displayHelpers'
import { userAccess } from '@/mixins/user-access'
// third party
import moment from 'moment'

export default {
  name: 'AdPlannerEdit',
  mixins: [displayAlert, fullwidth, displayHelpers, partySearch, paging, userAccess, utils],
  data () {
    return {
      adPlanners: [],
      selectedAdGroup: null,
      storeParties: [],
      selectedStore: null,
      loading: false,
      menu: false,
      edgeSubscriber: false,
      suggestedFilterOptions: ['All', 'Meat', 'Grocery'],
      suggestedFilter: 'All',
    }
  },
  watch: {
    selectedAdGroup: {
      handler (newValue, oldValue) {
        if (newValue) {
          sessionStorage.setItem('selected_group', JSON.stringify(newValue))
          if (oldValue) sessionStorage.removeItem('selected_store')
          this.getStoreParties()
        }
      },
      deep: true
    },
    selectedStore: {
      handler (newValue) {
        if (newValue) {
          sessionStorage.setItem('selected_store', JSON.stringify(newValue))
          this.edgeSubscriber = this.selectedStore?.edge_subscriber ?? false
          this.getAdPlanners()
        }
      },
      deep: true
    },
    userAdGroups: {
      handler (newValue) {
        if (newValue?.length > 0 && !this.selectedAdGroup) {
          this.selectedAdGroup = newValue[0]
        }
      },
      deep: true
    },
    activeUserRelatedPartyIds: {
      handler(newValue) {
        if (newValue.length > 0) {
          this.getStoreParties()
        }
      }
    }
  },
  beforeCreate () {
    this.$store.dispatch('getAdGroups')
  },
  created () {
    this.nonTableHeight = 235
    if (sessionStorage.selected_group) {
      this.selectedAdGroup = JSON.parse(sessionStorage.selected_group)
    }
    if (this.userAdGroups.length > 0 && !this.selectedAdGroup) {
      this.selectedAdGroup = this.userAdGroups[0]
    }
    if (sessionStorage.selected_store) {
      this.selectedStore = JSON.parse(sessionStorage.selected_store)
      this.edgeSubscriber = this.selectedStore.edge_subscriber
    } else { this.getStoreParties() }
    this.tableChanged = this.tableChange(this.getAdPlanners)
  },
  computed: {
    headers () {
      return [
        { sortable: false, class: 'accent', show: true },
        { text: 'Ad Name', align: 'left', sortable: true, value: 'ad_name', class: 'accent white--text', width: 'auto', show: true },
        { text: 'Ad Start Date', align: 'center', sortable: true, value: 'ad_start_date', class: 'accent white--text', width: 'auto', show: true },
        { text: 'Ad End Date', align: 'center', sortable: true, value: 'ad_end_date', class: 'accent white--text', width: 'auto', show: true },
        { text: 'Last Order Date', align: 'center', sortable: true, value: 'lastOrderDate', class: 'accent white--text', width: 'auto', show: true },
        { text: 'Status', align: 'center', sortable: true, value: 'ad_status', class: 'accent white--text', width: 'auto', show: true },
        { text: 'Ad Details', align: 'center', sortable: false, value: 'ad_details', class: 'accent white--text', width: 'auto', show: true }
      ].filter(header => header.show)
    },
    disablePrevious () {
      return ((this.page - 1) * this.pageSize) === 0
    },
    disableNext () {
      return this.adPlanners.length < this.pageSize
    },
    filteredAdPlanners () {
      return this.adPlanners
    },
    suggestedOrderStore() {
      return this.$auth.tenant === 'alliance-retail-group' && this.edgeSubscriber
    }
  },
  methods: {    
    async getStoreParties () {
      const partyId = this.selectedAdGroup?.id
      if (!partyId) return
      let stores = []
      try {
        const res = await Party.getActiveStoresByAdGroup(partyId)
        if (res?.data?.length > 0) {
          stores = res.data.map(party => {
            party.id = party.store_party_id
            party.name = `#${party.wholesaler_store_number || ''} ${party.store_name}`
            return party
          })
        }

        if (this.limitAccessByRelatedStores || this.isARGOwner) {
          stores = stores.filter(result => {
            return this.activeUserRelatedPartyIds.includes(result.id)
          })
        }

        this.storeParties = stores
        if (this.storeParties.length > 0) {
          this.selectedStore = sessionStorage.selected_store
            ? JSON.parse(sessionStorage.selected_store)
            : this.storeParties[0]
          this.edgeSubscriber = this.selectedStore.edge_subscriber
        } else {
          this.selectedStore = null
          this.edgeSubscriber = false
        }
      } catch (err) {
        this.handleError(err)
      } finally {
        this.getAdPlanners()
      }
    },
    async getAdPlanners () {
      this.loading = true
      try {
        const partyId = this.selectedAdGroup.id
        if (!partyId) {
          this.adPlanners = []
          return
        }

        const storeId = this.selectedStore?.id
        if (!storeId) {
          this.adPlanners = []
          return
        }

        let res = null;

        if (this.suggestedOrderStore) {
          res = await AdRetails.getSuggestedAdPlanners(partyId, storeId, this.from, this.pageSize, false, true)
        } else {
          res = await AdRetails.getAdPlanners(partyId, this.from, this.pageSize, storeId, false, true)
        }

        const planners = res?.data || []

        // Only show ad plans that start on/after 12-29-2025. Anything before that shouldn't be edited in this system
        const filtered_planners = planners.filter(planner => planner?.ad_start_date >= '2025-12-29')
        
        const final_planners = filtered_planners.map(planner => {
          return { ...planner, ...this.getFinalOrderDates(planner.ad_start_date, this.suggestedOrderStore, planner.meat_grid) }
        })

        this.adPlanners = final_planners
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    async viewAdPlanner (adPlanner) {
      if (!this.selectedAdGroup?.id || !this.selectedStore?.id) {
        return this.handleError(new Error('You must select both a store and an ad group to continue.'))
      }

      sessionStorage.setItem('store_id', this.selectedStore.id)
      sessionStorage.setItem('store_name', this.selectedStore.name)
      sessionStorage.setItem('edge_subscriber', JSON.stringify(this.edgeSubscriber))
      return this.$router.push({
        name: 'AdPlannerEditItems',
        params: {
          store_id: this.selectedStore.id,
          ad_id: adPlanner.ad_id,
          meat_grid: adPlanner.meat_grid || false,
          adPlanner: adPlanner,
          ad_group: this.selectedAdGroup,
          store_name: this.selectedStore.name,
          storeParties: this.storeParties,
          edge_subscriber: this.edgeSubscriber
        }
      })
    },
    getEditStatus(ad) {
      const today = moment().format('YYYY-MM-DD')

      if (today >= ad.ad_start_date) {
        return { status_name: "CLOSED", color: "grey darken-1" }
      } else if (today > ad.lastOrderDate) {
        return { status_name: "ORDERING CLOSED", color: "orange darken-2" }
      } else {
        return { status_name: "OPEN", color: "green" }
      }
    }
  }
}
</script>
